export const getLocale = (): string => {
    return window.__epic_client_state.locale;
};
